import { render, staticRenderFns } from "./WalletAdminWalletsTable.vue?vue&type=template&id=745af2d9&scoped=true&"
import script from "./WalletAdminWalletsTable.vue?vue&type=script&lang=js&"
export * from "./WalletAdminWalletsTable.vue?vue&type=script&lang=js&"
import style0 from "./WalletAdminWalletsTable.vue?vue&type=style&index=0&id=745af2d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745af2d9",
  null
  
)

export default component.exports